import { css } from '@microsoft/fast-element';
import { MainStyles } from '../../../main/main.styles';
import CascadeLogo from '../../../assets/cascade-logo-large.svg';
import ExampleIcon from '../../../assets/example-icon.svg';

export const LandingPageStyles = css`
  ${MainStyles}
  
  :host {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    overflow: auto;
  }

  .header-hero-wrapper {
    width: 1280px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
  }

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 35px 0 0;
    height: 110px;
  }

  .header-left {
    display: flex;
  }

  .header-right {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .logo {
    position: relative;
    margin-right: 42px;
    padding-left: 65px;
    font-family: GranthaSangamMN-Bold, "Grantha Sangam MN Bold", "Grantha Sangam MN", sans-serif;
    font-weight: 700;
    font-size: 25px;
    background: -webkit-linear-gradient(0.5turn, #08B57B, #6ADC27);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    display: flex;
    align-items: center;
  }

  .logo::before {
    content: '';
    position: absolute;
    width: 54px;
    height: 58px;
    background: url(${CascadeLogo}) no-repeat;
    top: 0;
    left: 0;
  }

  .main-menu {
    display: flex;
  }

  .main-menu zero-button {
    height: 57px;
    border-radius: 0px;
    background-color: transparent;
    color: #333333;
    margin-top: 0px;
    margin-bottom: 0px;
    font-size: 16px;
    font-family: "GillSans", "Gill Sans", sans-serif;
  }


  .main-menu zero-button.selected,
  .main-menu zero-button:hover {
    position: relative;
    height: 57px;
    background-color: transparent;
    font-size: 16px;
    font-family: "GillSans", "Gill Sans", sans-serif;
    font-weight: 500;
    color: #0a9664;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .main-menu zero-button.selected::before {
    content: "";
    position: absolute;
    width: calc(100% - 20px);
    height: 3px;
    background: linear-gradient(90deg, var(--secondary-color) 35%, var(--primary-color) 100%);
    bottom: 0px;
    left: 10px;
    right: 0px;
  }

  .login-button {
    width: 160px;
    height: 45px;
  }

  .hero-container {
    height: calc(100vh - 110px);
    max-height: 700px;
    min-height: 550px;
    display: flex;
    gap: 30px;
  }

  .hero-text {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .hero-title {
    font-size: 68px;
    font-family: "GillSans", "Gill Sans", sans-serif;
    background: -webkit-linear-gradient(0.5turn, #08B57B, #6ADC27);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 35px;
  }

  .hero-description {
    font-size: 28px;
    font-family: "GillSans", "Gill Sans", sans-serif;
    color: #212121;
  }

  .hero-animation {
    width: 50%;
    height: 100%;
  }

  .why-cascade-wrapper {
    background-color: #e4e4e4;
    width: 100%;
    height: auto;
    display: flex;
  }

  .why-cascade-container {
    width: 1280px;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding-bottom: 80px;
  }

  .why-cascade-container>.header {
    font-size: 48px;
    font-family: "GillSans", "Gill Sans", sans-serif;
    background: -webkit-linear-gradient(0.5turn, #08B57B, #6ADC27);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-top: 30px;
  }

  .why-cascade-container>.description {
    max-width: 702px;
    font-size: 24px;
    font-family: "GillSans-Light", "Gill Sans Light", "Gill Sans", sans-serif;
    color: #000333;
    margin-bottom: 40px
  }

  .why-cascade-container .tiles-wrapper {
    display: flex;
    gap: 45px;
  }

  .why-cascade-container .tiles-wrapper .tile {
    background-color: white;
    position: relative;
    padding: 120px 16px 25px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .why-cascade-container .tiles-wrapper .tile:before {
    content: "";
    position: absolute;
    height: 4px;
    background: -webkit-linear-gradient(right, #08B57B, #6ADC27);
    width: 100%;
    top: 0;
    left: 0;
  }

  .why-cascade-container .tiles-wrapper .tile:after {
    content: '';
    position: absolute;
    width: 75px;
    height: 75px;
    top: 27px;
    left: 50%;
    transform: translate(-50%, 0);
    background: url(${ExampleIcon}) no-repeat center;
  }

  .why-cascade-container .tiles-wrapper .tile .heading {
    font-size: 24px;
    color: #333333;
    font-family: "GillSans", "Gill Sans", sans-serif;
    padding-bottom: 10px;
  }

  .why-cascade-container .tiles-wrapper .tile .description {
    font-size: 15px;
    color: #797979;
    font-family: "GillSans", "Gill Sans", sans-serif;
    text-align: center;
  }




  /**
   * Footer
   */

  .footer-wrapper {
    background-color: #08B57B;
    width: 100%;
    height: auto;
    display: flex;
  }

  .footer-container {
    width: 1280px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 auto;
    padding-top: 40px;
    padding-bottom: 40px;
  }

  .links {
    display: flex;
    gap: 10px;
  }

  .link {
    font-family: "GillSans-Light", "Gill Sans Light", "Gill Sans", sans-serif;
    font-size: 14px;
    font-weight: 400;
    
  }

  .link:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;
